/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef } from "react";
import { NumberFormatBaseProps, NumericFormat } from "react-number-format";

interface CustomProps extends NumberFormatBaseProps {
  onChange?: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props: CustomProps,
  ref,
) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        if (onChange) {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }
      }}
      thousandSeparator="."
      decimalSeparator=","
      valueIsNumericString
      prefix="$"
    />
  );
});

export default { NumericFormatCustom };
